import React from "react"

import { CustomLink, Icon } from "@/components"
import { getLinkWithPathPrefix } from "@/utils"

interface IProps {
  link?: string
  children: React.ReactNode
  isSystemLink?: boolean
}

const MenuLink: React.FC<IProps> = ({ link, children, isSystemLink }) => {
  return !!link ? (
    <CustomLink
      className={`a-dark ${isSystemLink ? "system-link" : ""}`}
      linkTo={getLinkWithPathPrefix(link)}
    >
      {children}
      {isSystemLink && <Icon name="arrow-right" />}
    </CustomLink>
  ) : (
    <>{children}</>
  )
}

export default MenuLink
